import { render, staticRenderFns } from "./modal-pendings.vue?vue&type=template&id=0b339c1a&scoped=true"
import script from "./modal-pendings.vue?vue&type=script&lang=js"
export * from "./modal-pendings.vue?vue&type=script&lang=js"
import style0 from "./modal-pendings.vue?vue&type=style&index=0&id=0b339c1a&prod&scoped=true&lang=css"
import style1 from "./modal-pendings.vue?vue&type=style&index=1&id=0b339c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b339c1a",
  null
  
)

export default component.exports